import { Component, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { ActivatedRoute, Router } from "@angular/router";
import { LogService } from "@rubbl-core";
import { SearchRequest, SearchResultsService } from "@rubbl-search-results";

// todo create a generic filter component so that the sidebar and topbar(mobile filter) can use the same logic
@Component({
  selector: "app-router-sidebar-search-results",
  templateUrl: "./router-sidebar-search-results.component.html",
  styleUrls: ["./router-sidebar-search-results.component.scss"],
})
export class RouterSidebarSearchResultsComponent implements OnDestroy {
  searchRequest: SearchRequest;
  searchRequestSubscription: Subscription;
  location: string = "";

  loadingPrimaryTypes: boolean = false; // this is for hiding certain facets that when changing the primary type

  searchResultsUrl: string[];
  mapUrl: string[];

  constructor(private searchResultsService: SearchResultsService, private router: Router, private logService: LogService, private route: ActivatedRoute) {
    this.searchRequestSubscription = this.searchResultsService.searchRequest$.subscribe((searchRequest: SearchRequest) => {
      this.searchRequest = searchRequest;
      this.location = this.searchRequest.location?.toCityStateSeo() || "";
      this.loadingPrimaryTypes = false;

      const cityStateForSearch = this.searchResultsService.searchRequest.location.toCityStateSeo();
      let primaryType = this.route.firstChild.firstChild.snapshot.paramMap.get("primaryType") || "all";
      primaryType = primaryType.replace(/-/g, " ");
      const make = this.route.firstChild.firstChild.snapshot.paramMap.get("make");

      // reason for complex logic is to prevent the stuttering of the red active link bar
      const searchResultsUrl = ["./equipment-rentals"];
      const mapUrl = ["./map"];

      searchResultsUrl.push(primaryType);
      mapUrl.push(primaryType);

      if (cityStateForSearch) {
        searchResultsUrl.push(cityStateForSearch);
        mapUrl.push(cityStateForSearch);
      }
      if (make) {
        searchResultsUrl.push(make);
        mapUrl.push(make);
      }

      this.searchResultsUrl = searchResultsUrl;
      this.mapUrl = mapUrl;
    });
  }

  ngOnDestroy() {
    this.searchRequestSubscription?.unsubscribe();
    this.searchResultsService.resetSearchRequest();
  }

  filterPrimaryType(primaryType?: string) {
    this.loadingPrimaryTypes = true;
    this.searchRequest.onPrimaryTypeChange(primaryType);
    this.filter();
    this.logService.pushTagToGtm({ event: "searchFilter", filterCategory: "Primary Type", filterSelection: primaryType ? primaryType : "Any" });
  }

  filterTypeDefinition(type: string) {
    this.searchRequest.onTypeDefinitionChange();
    this.filter();
    this.logService.pushTagToGtm({ event: "searchFilter", filterCategory: "Type Definition", filterSelection: type });
  }

  filterMake() {
    this.searchRequest.onMakeChange();
    this.filter();
  }

  filterModel() {
    this.searchRequest.onModelChange();
    this.filter();
  }

  buyItNowOrRtoChange() {
    if (this.searchRequest.buyItNowEnabled.selected || this.searchRequest.rpoEnabled.selected) {
      this.searchRequest.location.selectedRadius = "anywhere";
    } else {
      this.searchRequest.location.selectedRadius = "250";
    }
    this.filter();
  }

  filter() {
    this.searchResultsService.filterResults();
  }

  swapView() {
    const url = this.searchRequest.swapView();
    this.router.navigate([url], { queryParamsHandling: "merge" });
  }
}
